import React from 'react'
import t from '../i18n/translations/translations'

export default function AcceptPolicyLabel({lang}) {
  return lang === 'es' ? (
        <p>
            {t.accept_privacy_i_have_read.es}
            <a
                target="_blank"
                rel="noopener noreferrer"
                href="/es/politica-privacidad"
            >
                {' '}
                 <strong>{t.accept_privacy_privacy.es}</strong>.
            </a>
        </p>
    ) : (
        <p>
            <a
                target="_blank"
                rel="noopener noreferrer"
                href="/eu/pribatasun-politika"
            >
                <strong>{t.accept_privacy_privacy.eu}</strong>{' '}
            </a>
            {t.accept_privacy_i_have_read.eu}.
        </p>
    )
}
